import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
// @ts-ignore
import { Button } from '@netbasequid/core'
import { ScrollbarStyle } from 'styles'

export const DashboardViewContainer = styled.div<{ $mode: Theme }>`
  height: 100vh;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 48px 1fr;
  overflow: auto;
  background: ${({ $mode }: { $mode: Theme }) => sys[$mode].elevation[0].background};
  ${ScrollbarStyle}
`

export const DashboardViewBody = styled.div`
  padding: 24px 32px;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 52px 1fr;
  overflow: auto;
  background: ${({ mode }: { mode: Theme }) => sys[mode].elevation[0].background};
`

export const ActionsListContainer = styled.div`
  padding-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`

export const ActionsListLeft = styled.div`
  display: flex;
  gap: 16px;
`

export const SearchBarContainer = styled.div`
  width: 400px;
  background: ${({ mode }: { mode: Theme }) => sys[mode].elevation[100].background};
`

export const ActionsListRight = styled.div`
  display: flex;
  gap: 8px;
`

export const BottomContainer = styled.div`
  border-radius: 2px;
  overflow: auto;
  display: flex;
  background: ${({ mode }: { mode: Theme }) => sys[mode].elevation[100].background};
  box-shadow: ${({ mode }: { mode: Theme }) => sys[mode].elevation[100].boxShadow};
`

export const ButtonContainer = styled.div``

export const StyledLink = styled.a`
  display: contents;
  text-decoration: none;
`

export const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  white-space: nowrap;
`

export const BottomLabelContainer = styled.div`
  box-sizing: border-box;
  width: 208px;
  height: 100%;
  padding: 20px 4px 0 0;

  & > * {
    box-sizing: border-box;
    height: 100%;
  }
`

export const Divider = styled.div`
  width: 1px;
  flex: none;
  background-color: ${({ mode }: { mode: Theme }) => sys[mode].common.divider[100]};
`

export const ListTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 20px;
  overflow: hidden;
`

export const CategoryButtonContainer = styled.div`
  width: fit-content;
  margin-left: -8px;
`

export const PillContainer = styled.div`
  width: fit-content;
  margin: 16px 0 20px 0;
`
